import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  image: {
    transform: props => `
    rotate(${props?.cropRotate}deg) 
    scale(${props?.cropFlip.x || 1}, ${props?.cropFlip.y || 1})`,
  },
});

export default useStyles;
